import React from 'react';
import { Button } from '@adobe/react-spectrum';
import { withTheme } from '../../ThemeProvider';
import styles from './SecondaryActionButton.module.less';

const SecondaryActionButton = ({ children, ...props }) => {
  return (
    <div className={styles.container}>
      <Button UNSAFE_className={styles.button} UNSAFE_style={{ borderRadius: '40px' }} {...props} variant="cta">
        {children}
      </Button>
    </div>
  );
};

SecondaryActionButton.displayName = 'SecondaryActionButton';

export default withTheme(SecondaryActionButton);
